var swiper = new Swiper(".content-slider", {
  breakpoints: {
    1200: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    989: {
      slidesPerView: 2.4,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1.3,
      spaceBetween: 20,
    }
  }
});
